import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledHeading2 = makeDefaultTypographyStyled(
  'Heading2',
  'h2',
  2.07,
  1.2,
);
